import { FC } from 'react';
import { ESortDirection } from 'ui/EasTable/types';
import { TActionSpeedDialProps } from './types';

export const ActionSpeedDial: FC<TActionSpeedDialProps> = ({
	sortable,
	onChangeSort,
	sortDirection,
}) => {
	const handleSort = () => {
		if (!sortable) return;
		if (sortDirection === ESortDirection.ASC) {
			onChangeSort?.(ESortDirection.DESC);
		} else if (sortDirection === ESortDirection.DESC) {
			onChangeSort?.(ESortDirection.ASC);
		} else {
			onChangeSort?.(ESortDirection.ASC);
		}
	};

	return (
		<div
			style={{ position: 'absolute', right: '0', top: '0', width: '100%', height: '100%' }}
			className="action-speed-dial"
			onClick={handleSort}
		/>
	);
};
